var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tab-item',{attrs:{"label":_vm.label,"icon":_vm.icon,"value":_vm.id}},[_c('section-box',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }